import { v4 as uuidv4 } from 'uuid';
import { getAccessFromDB, getSharedListById } from '../redux/action/userActivityAction';
import store from '../redux/store';
import ACTION_TYPES from '../redux/types';
import { renderAlert } from '../CommonComponents/Alert/Alert';
import { fetchSheetListByWorkbookId, searchBySheetId, uploadExcelToOneDrive } from '../redux/action/sheetAction.js';
import { getMultipleSheetsAsExcel } from 'ag-grid-enterprise';
import { getProjectTemplateColumns, RollupListColumns } from '../utils/constantData';
import { POST } from '../service/axiosMethods';
import { ELASTIC_URL } from '../utils/apiConstant';
import { getStartAndEndDate, valueChangedByValueGetter } from '../MiniProducts/xTables/helper/helperFunctions.js';
import { TimeSeriesColumngroup } from '../MiniProducts/xTables/components/Grid/gridHelperFunctions';
import { deleteChildrenFromColumns } from '../redux/action/currentSheetDataAction';
import { fetchWorkbookByParent } from '../redux/action/workSpaceAction.js';
import { FETCH_WORKSPACES } from '../GraphQL/Queries.js';
import apolloGraphQlClient from '../GraphQL/DataAccessGraphQLClient.js';

// not used
export function sendHttpRequest(url, method, body) {
    let headers = { 'Content-Type': 'application/json' };
    let requestOptions = {
        method: method,
        headers: headers,
    };
    if (body) {
        requestOptions["body"] = body;
    }
    return fetch(url, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if ((result.error === undefined || result.error.statusCode === undefined) && result) {
                    return result;
                }
            },
            (error) => {
                console.log("==> HTTP ERROR: " + error);
            }
        )
        .catch((error) => console.log("==> HTTP ERROR: " + error))
}


//! Redundant - function is not used.
export const sortedNodes = (arrayData, rootNode, rowsObject) => {
    //if no rootNode found return empty array from there
    console.log("Checking Rootnode and rowObjcet", rootNode, rowsObject);
    try {
        if (!rootNode) {
            return [];
        }

        //make a sorted node array to store the sorted value
        const sortedNodes = [];
        // Add the root node to the sorted array
        sortedNodes.push(rootNode);

        // create a function to find next node by given current Node
        const getNextNode = (currentNode, rowsObject) => {
            const nextNodeId = currentNode ? currentNode.next_node.toString() : "null"
            if (nextNodeId == "null") {
                // this means the current node is the last element in the array
                return "null"
            } else {
                // otherwise find the next node in the original array
                return rowsObject[nextNodeId]
            }
        }

        //find next node and add it to array until there is no more nodes are left
        let currentNode = rootNode;
        let nextNode = currentNode ? getNextNode(currentNode, rowsObject) : "null"
        console.log("Checking Next Node returned by func", nextNode);

        while (nextNode && nextNode != "null") {
            sortedNodes.push(nextNode);
            if (currentNode != nextNode) currentNode = nextNode;
            else break
            nextNode = getNextNode(currentNode, rowsObject);
        }

        // return Sorted Array
        return sortedNodes;
    } catch (error) {
        console.log("Checking error in generating rowData using sorted  Node function", error);
    }

}
// not used
export const addEmptyRows = (rows) => {
    for (let i = 1; i <= 10; i++) {
        let row = null;
        rows.push(row);
    }
    return rows;
}

// not used 
export const copyValue = (params) => {
    window.copiedValue = params.value
    navigator.clipboard.writeText(params.value)
}


// need to look into 
export const getRowsToDelete = (gridRef, currentSheetRows) => {
    let sheetDataIdsToDelete = new Set();
    let sheetDataIdsAvailable = new Set();
    gridRef.current.api.forEachNode(node => {
        let row = node.data;
        if (row && row.id) {
            sheetDataIdsAvailable.add(row.id);
        }
    });
    if (currentSheetRows) {
        currentSheetRows.forEach((sheetRow) => {
            if (sheetRow && sheetRow.id && !sheetDataIdsAvailable.has(sheetRow.id)) {
                sheetDataIdsToDelete.add(sheetRow.id);
            }
        });
    }
    return sheetDataIdsToDelete;
}
export const getSmallestSelectedIndex = (selectedIndexes) => {
    let smallestSelectedRowIndex = Math.min(...selectedIndexes);
    return smallestSelectedRowIndex;
};

// duplicate 
export const getLargestSelectedIndex = (selectedIndexes) => {
    console.log("Checking Selected Index", selectedIndexes);
    let largestSelectedRowIndex = Math.max(...selectedIndexes);
    return largestSelectedRowIndex;
};

export const getSelectedRowIndexes = (gridRef) => {
    let selectedNodes = gridRef.current.api.getSelectedNodes();
    let selectedRowIndexes = [];
    selectedNodes.forEach((selectedNode) => {
        selectedRowIndexes.push(selectedNode.rowIndex);
    });
    return selectedRowIndexes;
}


export const columnDefs = [
    {
        headerName: 'Primary Column',
        field: 'primary',
        minWidth: 200,
        colId: 'ag-Grid-AutoColumn',
        cellEditor: 'agTextCellEditor',
        suppressMovable: true,
        editable: true,
        lockPosition: true,
        cellRendererParams: {
            suppressCount: true,
        },
    },
    {
        headerName: 'Column 1',
        field: 'Column1',
        colId: 'Column 1',
        cellEditor: 'agTextCellEditor',
        minWidth: 150,
    },
    {
        headerName: 'Column 2',
        field: 'Column2',
        colId: 'Column 2',
        cellEditor: 'agTextCellEditor',
        minWidth: 150,
        // valueGetter: params => params.getValue('column 3') || 'N/A',
    },
    {
        headerName: 'Column 3',
        field: 'Column3',
        minWidth: 150,
        colId: 'Column 3',
        cellEditor: 'agTextCellEditor',
        // valueGetter: params => params.getValue('column 4') || 'N/A',
    },
    {
        headerName: 'Column 4',
        field: 'Column4',
        minWidth: 150,
        colId: 'Column 4',
        cellEditor: 'agTextCellEditor',
        // valueGetter: params => params.getValue('column 5') || 'N/A',
    },
    {
        headerName: 'Column 5',
        field: 'Column5',
        minWidth: 150,
        colId: 'Column 5',
        cellEditor: 'agTextCellEditor',
        // valueGetter: params => params.getValue('column 6') || 'N/A',
    },
];
const defaultSheetColumns = (uuid) => {
    return [
        {
            "columnElasticid": `${uuid()}_es`,
            "width": "300",
            "colId": "#",
            "field": "#",
            "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
            "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null,
            "pivot": false, "pivotIndex": null, "aggFunc": null, "pinned": "left", "sort": null, "sortIndex": null, "rowDrag": true
        },
        {
            "columnElasticid": `${uuid()}_es`,
            "width": "300",
            "colId": "ag-Grid-AutoColumn",
            "field": "primaryCol",
            "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true, 
            "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null,
            "pivot": false, "pivotIndex": null, "aggFunc": null, "sort": null, "sortIndex": null, "headerName": "Primary Column",
            "suppressMovable": true, "lockPosition": true
        },
        {
            "columnElasticid": `${uuid()}_es`,
            "width": "300",
            "colId": "Column 1",
            "field": "Column1",
            "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
            "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null,
            "pivot": false, "pivotIndex": null, "aggFunc": null, "sort": null, "sortIndex": null, "headerName": "Column 1"
        },
        {
            "columnElasticid": `${uuid()}_es`,
            "width": "300",
            "colId": "Column 2",
            "field": "Column2",
            "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
            "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null, 
            "pivot": false, "pivotIndex": null, "aggFunc": null, "sort": null, "sortIndex": null, "headerName": "Column 2"
        },
        {
            "columnElasticid": `${uuid()}_es`,
            "width": "300",
            "colId": "Column 3",
            "field": "Column3",
            "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true, 
            "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null, 
            "pivot": false, "pivotIndex": null, "aggFunc": null, "sort": null, "sortIndex": null, "headerName": "Column 3"
        },
        {
            "columnElasticid": `${uuid()}_es`,
            "width": "300",
            "colId": "Column 4",
            "field": "Column4",
            "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
            "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null, 
            "pivot": false, "pivotIndex": null, "aggFunc": null, "sort": null, "sortIndex": null, "headerName": "Column 4"
        },
        {
            "columnElasticid": `${uuid()}_es`,
            "width": "300",
            "colId": "Column 5",
            "field": "Column5",
            "enableValue": true, "enableRowGroup": true, "groupDefaultExpanded": 1, "filter": true, "editable": true,
            "resizable": true, "autoHeaderHeight": true, "wrapHeaderText": true, "rowGroup": false, "rowGroupIndex": null, 
            "pivot": false, "pivotIndex": null, "aggFunc": null, "sort": null, "sortIndex": null, "headerName": "Column 5"
        },
    ]
}

const generateSheetName = (newWorkbook, isWorkbooktemplate, sheetName, sheetListData, selectedWorkbookId) => {
    if (newWorkbook === 'newWorkbook') {
        return isWorkbooktemplate ? sheetName : "Sheet (1)";
    }

    const sheetListObj = Object.fromEntries(sheetListData?.map(sheet => [sheet.name, true]) || []);
    let name
    if (sheetName) {
        name = sheetName
    }
    else if (!sheetListData?.length === 0) {
        name = "Sheet (1)"
    }
    else if (sheetListData && sheetListData[0]?.workbook_id !== selectedWorkbookId) {
        name = "Sheet (1)"
    }
    else {
        name = `Sheet (${sheetListData?.length + 1})`;
    }

    let count = sheetListData?.length + 1;
    while (sheetListObj[name]) {
        count++;
        name = `Sheet (${count})`;
    }
    return name;
};

const handleSheetType = async (sheetInfo, sheetType, referenceSheetId, cols, uuid) => {
    if (sheetType === 'project') {
        sheetInfo.doc.columns = await setupProjectSheet(cols);
    } else if (sheetType === 'rolluplist') {
        sheetInfo.doc.columns = RollupListColumns;
    } else if (sheetType === 'view') {
        delete sheetInfo.doc.columns;
    } else if (sheetType === 'checkinagent') {
        sheetInfo.doc.referenceSheetId = referenceSheetId;
    } else if (!cols && sheetType !== 'xPad') {
        sheetInfo.doc.columns = defaultSheetColumns(uuid);
    } else if (sheetType === 'xPad') {
       if(sheetInfo?.doc?.columns) delete sheetInfo.doc.columns;
    } else {
        sheetInfo.doc.columns = cols;
    }
    return sheetInfo;
};

export const removeTimeSeriesColumns = (columns) => {
    const isTimeSeriesCol = (col) => {
        if (col.block === 'timeseries') return true;
        if (typeof col.block === 'string') {
            try {
                const parsed = JSON.parse(col.block);
                if (parsed?.type === 'timeseries') return true;
            } catch (_) {}
        }
        return false;
    };

    let position = null;
    const filtered = columns.filter((col, idx) => {
        if (isTimeSeriesCol(col)) {
            if (position === null) position = idx;
            return false;
        }
        return true;
    });

    return { columns: filtered, position };
};

const setupProjectSheet = async (columns) => {
    const isTemplate = !!columns?.length;
    columns = columns?.length ? columns : getProjectTemplateColumns();

    const { columns: cleanedColumns, position: tsPosition } = removeTimeSeriesColumns(columns);
    columns = cleanedColumns;

    const defaultStatusID = window.DEFAULT_STATUS_ID;
    const resp = await getSharedListById({ sharedlistId: defaultStatusID });
    let defaultStatusInfo = resp.data;

    if (!isTemplate || tsPosition !== null) {
        const { startDate, endDate } = getStartAndEndDate();
        const details = { startDate, endDate, frequency: "day" };
        const group = TimeSeriesColumngroup(details, columns, valueChangedByValueGetter, columns);

        let columnsToInsert = await deleteChildrenFromColumns(JSON.parse(JSON.stringify([group, ...group.children])));
        const position = tsPosition !== null ? tsPosition : columns.length - 1;

        columns = [...columns.slice(0, position), ...columnsToInsert, ...columns.slice(position)];
    }

    return columns.map(col => {
        const { template: _t, ...colWithoutTemplate } = col;
        const base = colWithoutTemplate;
        return col.headerName === 'Status' ? {
            ...base,
            listData: defaultStatusInfo.options,
            sharedListInfo: { ...defaultStatusInfo, options: JSON.parse(defaultStatusInfo.options) },
            sharedlistId: defaultStatusID
        } : base;
    });

};

export const makeSheetInfo = async ({
    userEmail,
    selectedWorkbookId,
    uuid,
    sheetListData,
    sheetType,
    sheetTypeSpecificInfo = {},
    newWorkbook,
    sheetName,
    referenceSheetId,
    isWorkbooktemplate,
    cols,
    workbook
}) => {
    const sheetname = generateSheetName(newWorkbook, isWorkbooktemplate, sheetName, sheetListData, selectedWorkbookId);
    const sheetIndex = window.SHEET_INDEX;
    let newSheetId = "sh_" + uuidv4()
    let sheetInfo = {
        "index": sheetIndex,
        "doc": {
            "id": newSheetId,
            "name": `${sheetname}`,
            "workbook_id": `${selectedWorkbookId}`,
            "user_email": `${userEmail}`,
            "user_id": `${userEmail}`,
            "notes": "",
            "attachments": [],
            "sheetType": sheetType || 'default',
            "sheet_identifier": uuidv4(),
            "l_id": workbook.l_id + '.' + newSheetId,
            "workspace_id" : workbook?.workspace_id?.startsWith('w_') ? workbook?.workspace_id : "myWorkbooks" , 
            ...(workbook?.copyOfOriginal ? { template_id: workbook.template_id } : {}),
            ...(workbook?.copyOfOriginal ? { copyOfOriginal: true } : {}),
            ...(workbook?.copyOfOriginal ? { sheet_scope: workbook.l_id.includes("publicTemplates") ? "public" : "private" } : {}),
            ...sheetTypeSpecificInfo,
        }
    }
   let updatedSheetInfo = await handleSheetType(sheetInfo, sheetType, referenceSheetId, cols, uuid);
    return updatedSheetInfo;
}
export const makeNewWorkbookname = (workbookListData) => {
    if (workbookListData.length == 0) return 'Workbook (1)'
    else {
        let workbookname
        let workbookListObj = {}
        workbookListData.forEach((workbook) => {
            workbookListObj[workbook.name] = true
        })
        workbookname = `Workbook (${workbookListData.length + 1})`
        let maxCount = workbookListData.length
        while (workbookListObj[workbookname]) {
            maxCount++;
            workbookname = `Workbook (${maxCount})`
        }
        return workbookname
    }
}

export const generateUniqueSheetName = (baseName, targetSheetList, maxLength = 31) => {
    const existingNames = targetSheetList.map(sheet => sheet.name);
    const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  
    // If base name is unused and fits, return it directly
    if (!existingNames.includes(baseName)) {
      return baseName.length > maxLength ? baseName.slice(0, maxLength) : baseName;
    }
    // Decide the suffix pattern: either (1), (2) or (1)(1), (1)(2)
    const getNextName = (suffixFormatFn) => {
      let counter = 1;
      let nextName = '';
      while (true) {
        nextName = suffixFormatFn(counter);
        if (!existingNames.includes(nextName)) return nextName;
        counter++;
      }
    };
  
    // If baseName already has a "(n)" at the end, append more like (1)(1)
    const endsWithNumberInParens = /\(\d+\)$/;
    if (endsWithNumberInParens.test(baseName)) {
      return getNextName((i) => {
        const full = `${baseName}(${i})`;
        return full.length > maxLength ? baseName.slice(0, maxLength - `(${i})`.length) + `(${i})` : full;
      });
    }
  
    // Otherwise, append (1), (2), ...
    return getNextName((i) => {
      const suffix = ` (${i})`;
      const allowedLength = maxLength - suffix.length;
      const trimmedBase = baseName.length > allowedLength ? baseName.slice(0, allowedLength) : baseName;
      return `${trimmedBase}${suffix}`;
    });
  };

  function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

// used
export const makeSheetName = (sheetListData) => {
    let sheetname;
    let sheetListObj = {}
    sheetListData.forEach((sheet) => {
        sheetListObj[sheet.name] = true
    })
    sheetname = sheetListData.length == 0 ? "Sheet (1)" : `Sheet (${sheetListData.length + 1})`
    let maxCount = sheetListData.length + 1
    while (sheetListObj[sheetname]) {
        maxCount++;
        sheetname = `Sheet (${maxCount})`
    }
    return sheetname;
}
// used 
export const checkifAlreadyExists = (newName, type, sheetList, workbookList) => {
    let arrayToTraverse = type === 'Sheet' ? sheetList : workbookList
    for (let i = 0; i < arrayToTraverse.length; i++) {
        if (arrayToTraverse[i]?.name?.trim() === (newName ? newName.trim() : '')) return true
    }
    return false
}
// used
export function calculateTimeDifference(startTimestamp, endTimestamp) {
    startTimestamp = new Date(startTimestamp)
    const MS_PER_MINUTE = 60 * 1000;
    const MS_PER_HOUR = MS_PER_MINUTE * 60;
    const MS_PER_DAY = MS_PER_HOUR * 24;
    const MS_PER_WEEK = MS_PER_DAY * 7;
    const MS_PER_MONTH = MS_PER_DAY * 30; // Approximation, can vary
    const MS_PER_YEAR = MS_PER_DAY * 365; // Approximation, can vary

    const timeDiff = Math.abs(endTimestamp - startTimestamp);

    const minutes = Math.floor(timeDiff / MS_PER_MINUTE);
    const hours = Math.floor(timeDiff / MS_PER_HOUR);
    const days = Math.floor(timeDiff / MS_PER_DAY);
    const weeks = Math.floor(timeDiff / MS_PER_WEEK);
    const months = Math.floor(timeDiff / MS_PER_MONTH);
    const years = Math.floor(timeDiff / MS_PER_YEAR);

    if (minutes < 60) {
        return `${minutes} min${minutes !== 1 ? 's ago ' : ' ago '}`;
    } else if (hours < 24) {
        return `${hours} hour${hours !== 1 ? 's ago ' : ' ago '}`;
    } else if (days < 7) {
        return `${days} day${days !== 1 ? 's ago ' : ' ago '}`;
    } else if (weeks < 4) {
        return `${weeks} week${weeks !== 1 ? 's ago ' : ' ago '}`;
    } else if (months < 12) {
        return `${months} month${months !== 1 ? 's ago ' : ' ago '}`;
    } else {
        return `${years} year${years !== 1 ? 's ago ' : ' ago '}`;
    }

}
// used
export async function fetchAccessFromLocalStorage(sheet_id) {
    let access = localStorage.getItem(`access_${sheet_id}`);
    // if(access) access=JSON.parse(access)
    // else {
    const user = store.getState().userReducer.userData;   
    access = await getAccessFromDB(sheet_id, user.email)
    if (!access) return { sheetacess: '', view: '' }
    access.accessInfo = access.highlevelaccess.split('')
    // }
    let accessObj = { Read: 'Full', Write: 'None', Share: 'None', Delete: 'None' };
    if (access) {
        let accessArr = access.accessInfo
        let Read = accessArr[0], Write = accessArr[1], Share = accessArr[2], Delete = accessArr[3];
        if (Read === "2" && access.Read == 'Full') accessObj['Read'] = 'Full';
        else if (Read === "1" || access.Read) accessObj['Read'] = access.Read

        if (Write === "2" && access.Write == 'Full') accessObj['Write'] = 'Full';
        else if (Write === "1" || access.Write) accessObj['Write'] = access.Write
        else accessObj['Write'] = 'None'

        if (Share === "2") accessObj['Share'] = 'Full';
        else if (Share === "1" || access.Share) accessObj['Share'] = access.Share
        else accessObj['Share'] = 'None'

        if (Delete === "2" && access.Delete == 'Full') accessObj['Delete'] = 'Full';
        else if (Delete === "1" || access.Delete) accessObj['Delete'] = access.Delete
        else accessObj['Delete'] = 'None'
    }
    return { sheetacess: accessObj, view: access.view }
}
// used 
export async function fetchSheetViewName(sheet_id) {
    const user = store.getState().userReducer.userData;
    let access = localStorage.getItem(`access_${sheet_id}`);
    if (access) {
        access = JSON.parse(access)
        return access.view
    }
    else {
        access = await getAccessFromDB(sheet_id, user?.email)
        return access.view
    }
}

export function capitalizeFirstLetter(str) {
    // Check if the input string is not empty
    if (str.length === 0) {
        return str; // Return an empty string if input is empty
    } else {
        // Capitalize the first letter and concatenate it with the rest of the string
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
}

function checkIfSheetSharedWithoutColAccess(sheetAccess) {
    const validValues = ["Full", "None"];
    for (let key in sheetAccess) {
        if (!validValues.includes(sheetAccess[key])) {
            return false; 
        }
    }
    return true; 
}
// used 
export const checkForAccess = (columns, sheetAccess, isLocked) => {
    let groupedColumns = putColumnsUnderParentGroups(columns)
    if (checkIfSheetSharedWithoutColAccess(sheetAccess)) {
        let updatedColumnsAfterAccess = [];
        updatedColumnsAfterAccess = groupedColumns.map(function (column) {
            let updatedColumn = {
                ...column,
                editable: sheetAccess.Write === "Full" && !isLocked,
                deleteable: sheetAccess.Delete === "Full"  && !isLocked,
                shareable: sheetAccess.Share === "Full" && !isLocked
            };

            if (column.colId === '#') {
                updatedColumn.editable = false;
                updatedColumn.deleteable = false;
                updatedColumn.shareable = false;
            } else if (column.colId === 'ag-Grid-AutoColumn') {
                updatedColumn.deleteable = false;
            }
        
            return updatedColumn;
        });
        
        return updatedColumnsAfterAccess;
    } else {
        if (sheetAccess.Read && sheetAccess.Read != 'Full' && sheetAccess.Read != 'None') sheetAccess.Read = JSON.parse(sheetAccess.Read)
        if (sheetAccess.Write && sheetAccess.Write != 'Full' && sheetAccess.Write != 'None') sheetAccess.Write = JSON.parse(sheetAccess.Write)
        if (sheetAccess.Delete && sheetAccess.Delete != 'Full' && sheetAccess.Delete != 'None') sheetAccess.Delete = JSON.parse(sheetAccess.Delete)
        if (sheetAccess.Share && sheetAccess.Share != 'Full' && sheetAccess.Share != 'None') sheetAccess.Share = JSON.parse(sheetAccess.Share)
        let readColumns = sheetAccess?.Read?.columns ? sheetAccess?.Read?.columns : []
        let writeColumns = sheetAccess?.Write?.columns ? sheetAccess?.Write?.columns : []
        let deleteColumns = sheetAccess?.Delete?.columns ? sheetAccess?.Delete?.columns : []
        let shareColumns = sheetAccess?.Share?.columns ? sheetAccess?.Share?.columns : []
        let updatedColumnsAfterAccess = []
        if (readColumns.length === 0) updatedColumnsAfterAccess = groupedColumns
        groupedColumns.forEach((col) => {
            if (writeColumns && writeColumns.length) {
                if (writeColumns.includes(col.colId) || sheetAccess.Write === 'Full') {
                    col.editable = true;
                }
                else col.editable = false;
            }
            else col.editable = false;
            if (deleteColumns && deleteColumns.length) {
                if (deleteColumns.includes(col.colId)) {
                    col.deleteable = true;
                }
                else col.deleteable = false;
            }
            else col.deleteable = false;
            if (shareColumns && shareColumns.length) {
                if (shareColumns.includes(col.colId)) {
                    col.shareable = true;
                }
                else col.shareable = false;
            }
            else col.shareable = false;
            if (col.colId === '#' || readColumns.includes(col.colId)) updatedColumnsAfterAccess.push(col)
        })

        return updatedColumnsAfterAccess
    }



}
export const removeUnnecessaryFieldsFromColumns = (column) =>{
    delete column.headerComponentParams
    delete column.headerGroupComponentParams
    return column
}
export const putColumnsUnderParentGroups=(columns)=>{
    if(!columns || columns.length === 0) return []
    const columnMap = new Map();

    // Initialize the column map with each column and potential children
    columns?.forEach(column => {
        removeUnnecessaryFieldsFromColumns(column)
        columnMap.set(column.colId, { ...column });
    });

    // Create the organized columns array
    const organizedColumns = [];

    // Iterate through columns and link parents and children
    columns?.forEach(column => {
        if (column.parent) {
            const parentColumn = columnMap.get(column.parent);
            if (parentColumn) {
                if (!parentColumn.children) {
                    parentColumn.children = [];
                    parentColumn.groupId=parentColumn.colId
                }
                let childColumn=columnMap.get(column.colId)
                if(parentColumn.children.length==0) delete childColumn.columnGroupShow
                else childColumn.columnGroupShow='open'
                const index = parentColumn.children.findIndex(child => child.colId === childColumn.colId);

                // If it exists, replace the childColumn in parentColumn.children
                if (index !== -1) {
                    parentColumn.children[index] = childColumn;
                } else {
                    parentColumn.children.push(childColumn);
                }
            }
            else if(column.field){
                delete column.parent
                organizedColumns.push(column)
            }
        } 
        else if(column.colId=='#'){
            organizedColumns.unshift(column)
        }
        else {
            organizedColumns.push(columnMap.get(column.colId));
        }
    });
    return organizedColumns.filter((column)=>column.field || column.children) // to remove  any group with no children
}
// Used 
export const checkForRowAccess = (rows, sheetAccess) => {
    let readRows = sheetAccess?.Read?.rows ? sheetAccess?.Read?.rows : []
    let updatedRowsAfterAccess = []
    if (readRows.length === 0) updatedRowsAfterAccess = rows
    readRows.forEach(({ start, end }) => {
        let allRows = [...rows]
        if (allRows[start - 1].l_id.split('.').length > 1) {
            let parentL_id = allRows[start - 1].l_id.split('.')[0];
            let parentIndex = returnParentRowIndex(allRows, parentL_id, start - 1);
            let endIndex = returnLeafRowIndex(allRows, parentL_id, end);
            updatedRowsAfterAccess = [...updatedRowsAfterAccess, ...allRows.splice(parentIndex, endIndex - parentIndex)]
        } else {
            updatedRowsAfterAccess = [...updatedRowsAfterAccess, ...allRows.splice(start - 1, end - start + 1)]
        }
    })

    return updatedRowsAfterAccess
}

// used 
const returnParentRowIndex = (rows, parentL_id, start) => {
    let parentIndex = 0;
    for (let i = 0; i <= start; i++) {
        if (rows[i].id === parentL_id) {
            parentIndex = i;
            break;
        }
    }
    return parentIndex;
};

//used 
const returnLeafRowIndex = (rows, parentL_id, end) => {
    let leafIndex = end;
    for (let i = end; i < rows.length; i++) {
        if (rows[i].l_id.split('.')[0] === parentL_id)
            leafIndex++;
        else
            break;
    }
    return leafIndex;
}


//not used anywhere
export const checkAndUpdateWorkbookInOneDrive=(workbookid)=>async (dispatch)=>{
    let {workbooksSyncedWithOneDrive,isOneDriveConnected}=store.getState().userActivityReducer
    if(isOneDriveConnected && workbooksSyncedWithOneDrive && workbookid) {
        let isBackedUp = workbooksSyncedWithOneDrive[workbookid]
        if(!isBackedUp){
            renderAlert('You have successfully connected to OneDrive .We will now start taking backup of your workbooks. We will let you know once this is complete. Meanwhile create a different tab for your work','success')
            dispatch({type:ACTION_TYPES.SET_USER_ACTIVITY_INFO,takeOneDriveBackup:true});
        }
    }
}
export const sendWorkbookToOneDrive=(workbook,sheet,user)=>async (dispatch)=>{
    dispatch(searchBySheetId(sheet.sheet_identifier, user, (sheet) => {
        let workbookDataAsString=getMultipleSheetsAsExcel({
            data: [sheet],
            fileName: workbook.name,
            mimeType:'string'
          })
        dispatch(uploadExcelToOneDrive(workbookDataAsString,[sheet],workbook,false,()=>{}))
    }))
   

}
export const debounce = (func, delay) => {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
};
export const getSharedwithMeWorkBooks = async (notifications, accessInfo, userData, deactivatedSharedWithMeWorkbooks) => {
    const sharedWithWorkBooks = [];
    const sharedWithMeWorkBooksMap = new Map();

    notifications.forEach((notification) => {
        const isWorkbook = notification?.entity_id?.startsWith('wb');
        if (isWorkbook) {
            const entity_id = `${userData.email}_${notification.entity_id}`;
            const accessInfoOfSheet = accessInfo.get(entity_id);

            if (JSON.parse(notification.metadata)?.type === 'Workbook' 
                && !sharedWithMeWorkBooksMap.has(notification.entity_id) 
                && accessInfoOfSheet) {
                
                sharedWithMeWorkBooksMap.set(notification.entity_id, true);

                let metadata;
                try {
                    metadata = JSON.parse(notification.metadata);
                } catch (e) {
                    console.error("Error parsing metadata for notification: ", notification, e);
                    return;
                }

                delete metadata.sheet_id;

                sharedWithWorkBooks.push({
                    id: notification.entity_id,
                    ownername: metadata.username,
                    l_id: `myWorkspace.Shared.SharedWithMeWorkbook.${notification.entity_id}`,
                    parent: 'SharedWithMeWorkbook',
                    name: notification.view,
                    user_email: notification.sender_id,
                    user_id: notification.sender_id,
                    workspace_id: "MyWorkspace",
                });
            }
        }
    });

    const filteredWorkbooks = sharedWithWorkBooks.filter(item => {
        return !deactivatedSharedWithMeWorkbooks?.some(deactivatedId => deactivatedId === item.id);
      });
    return filteredWorkbooks;
};
export const getWorkspaceWorkbookAndSharedSheets = async (userData) => {

    const { data } = await apolloGraphQlClient.query({
        query: FETCH_WORKSPACES,
        variables: {
            user_email: userData.email
        }
    });
    const fetchedWorkSpaces = data.fetchWorkSpaces.map(record => {
        const { __typename, ...rest } = record;
        return rest;
    });
  

  const workspaceWorkbookData = [];

  // Fetch all workbooks for each workspace
  for (const workspace of fetchedWorkSpaces) {
    let workbookData = await fetchWorkbookByParent(workspace.id);

    // Extract row data from each workbook
    const rows = workbookData.map(item => item._source);

    // Push into master list
    workspaceWorkbookData.push(...rows);
  }

  // Fetch sheet data for the collected workbook list
  const workspaceSharedSheets = await optimizedGetSharedwithMeWorkBookSheets(
    workspaceWorkbookData,
    userData
  );

  return {
    workspaceWorkbookData,
    workspaceSharedSheets,
  };
};

export const getSharedWithMeTemplateWorkbooks = async (notifications, accessInfo, userData, deactivatedSharedWithMeWorkbooks) => {
    const sharedWithWorkBooks = [];
    const sharedWithMeWorkBooksMap = new Map();

    notifications.forEach((notification) => {
        const isWorkbook = notification?.entity_id?.startsWith('wb');
        if (isWorkbook) {
            const entity_id = `${userData.email}_${notification.entity_id}`;
            const accessInfoOfSheet = accessInfo.get(entity_id);

            if (JSON.parse(notification.metadata)?.type === 'Template' 
                && !sharedWithMeWorkBooksMap.has(notification.entity_id) 
                && accessInfoOfSheet) {
                
                sharedWithMeWorkBooksMap.set(notification.entity_id, true);

                let metadata;
                try {
                    metadata = JSON.parse(notification.metadata);
                } catch (e) {
                    console.error("Error parsing metadata for notification: ", notification, e);
                    return;
                }

                delete metadata.sheet_id;

                sharedWithWorkBooks.push({
                    id: notification.entity_id,
                    ownername: metadata.username,
                    l_id: `sharedTemplates.${notification.entity_id}`,
                    parent: 'sharedTemplates',
                    name: notification.view,
                    copyOfOriginal: true,
                    user_email: notification.sender_id,
                    user_id: notification.sender_id,  
                });
            }
        }
    });

    const filteredWorkbooks = sharedWithWorkBooks.filter(item => {
        return !deactivatedSharedWithMeWorkbooks?.some(deactivatedId => deactivatedId === item.id);
      });
    return filteredWorkbooks;
};

export const formatSharedWbObject = (access, sheetList) => {
    const WbObject = {
        id: access.entity_id,
        ownername: access.sender_id,
        l_id: access.type === "Template"||sheetList[0]?.template_id?`sharedTemplates.${access.entity_id}`:`myWorkspace.Shared.SharedWithMeWorkbook.${access.entity_id}`,
        parent: access.type === "Template" || sheetList[0]?.template_id?'sharedTemplates':'SharedWithMeWorkbook',
        name: access.view,
        user_email: access.sender_id,
        user_id: access.sender_id,
        ...(access.type === "Template"?{copyOfOriginal:true}:{}),
        ...(sheetList[0]?.template_id || access.type === "Template" ? {} : { workspace_id: "MyWorkspace"}),
        sheetList : sheetList ? sheetList : []
    }

    return WbObject;
    
}

export const getSharedwithMeSheets= async(notifications,accessInfo,userData,deactivatedSharedWithMeSheets)=>{
    let sharedWithMeSheets=[],sharedWithMeSheetsMap=new Map();
    notifications.forEach((notification)=>{
        let entity_id=userData.email+"_"+notification.entity_id;
        let accessInfoOfSheet=accessInfo.get(entity_id)
        if(notification?.entity_id?.startsWith('sh') && notification.notification_type ==='Shared' && !sharedWithMeSheetsMap[notification.entity_id] && accessInfoOfSheet){
            sharedWithMeSheetsMap[notification.entity_id]=true;
            let metadata=JSON.parse(notification.metadata);
            delete metadata['sheet_id']
            sharedWithMeSheets.push({
                id:notification.entity_id,
                ownername: metadata.username,
                l_id:"myWorkspace.Shared.SharedWithMe."+notification.entity_id,
                parent:'SharedWithMe',
                name:notification.view,
                sheet_identifier:metadata.sheet_identifier,
                sheetType: accessInfoOfSheet.type,
                user_email:notification.sender_id,
                user_id:notification.sender_id,
                workspace_id:"MyWorkspace",
            })
        }
    })
    const filteredSheets = sharedWithMeSheets.filter(item => {
        return !deactivatedSharedWithMeSheets?.some(deactivatedId => deactivatedId === item.id);
      });
    return filteredSheets;
}

// old logic
export const getSharedwithMeWorkBookSheets = async (allsharedWithMeWorkBooks) => {
    let allsharedWithMeWorkBookssheets = [];
    for (const workbook of allsharedWithMeWorkBooks) {
        const sheetsOfWb = await fetchSheetListByWorkbookId(workbook.id);
        sheetsOfWb.forEach((sheet) => {
            if(sheet.l_id){
                const parts = sheet?.l_id?.split('.');
                if (parts?.length >= 2 && parts[1] === "myWorkbooks") { // Ensure 'myWorkbooks' exists in the correct place
                    parts[1] = "Shared.SharedWithMeWorkbook"; // Replace 'myWorkbooks'
                    sheet.l_id = parts.join('.'); // Reassemble the l_id
                }else{
                    sheet.l_id="myWorkspace.Shared.SharedWithMeWorkbook."+sheet?.workbook_id+"."+sheet.id
                }  
            }else{
                sheet.l_id="myWorkspace.Shared.SharedWithMeWorkbook."+sheet?.workbook_id+"."+sheet.id
            }
        });
        allsharedWithMeWorkBookssheets = [...allsharedWithMeWorkBookssheets, ...sheetsOfWb];
    }
    return allsharedWithMeWorkBookssheets;
};

export const optimizedGetSharedwithMeWorkBookSheets = async (allsharedWithMeWorkBooks, userData) =>{
    try { 
        let workbookIds= allsharedWithMeWorkBooks.map((wb)=>wb.id)
        const res = await POST(`${ELASTIC_URL}/sheet/getAllSheets`, {workbookIds});
        let allSharedWbSheets = res.data;
        const filteredSharedSheets = allSharedWbSheets.filter(sheet => {
            if (sheet.sheetType === 'filterSheet') {
                return sheet?.sheetTypeSpecificInfo?.owner === userData?.email;
            } else {
                return sheet.sheetType !== 'filterSheet';
            }
        } )
        let updatedSharedWbSheets = filteredSharedSheets.map((sheet) => {
            let updatedLid;

            // Workspace workbook sheets: keep their workspace-scoped l_id (w_xxx.wb_yyy.sh_zzz)
            if (sheet?.workspace_id && sheet?.workspace_id?.startsWith('w_')) {
                updatedLid = sheet.l_id || `${sheet.workspace_id}.${sheet.workbook_id}.${sheet.id}`;
            } else if (sheet.l_id) {
                const parts = sheet.l_id.split('.');
                if (parts.length >= 2 && parts[1] === "myWorkbooks") {
                    parts[1] = "Shared.SharedWithMeWorkbook";
                    updatedLid = parts.join('.');
                } else {
                    updatedLid = `myWorkspace.Shared.SharedWithMeWorkbook.${sheet.workbook_id}.${sheet.id}`;
                }
            } else {
                updatedLid = `myWorkspace.Shared.SharedWithMeWorkbook.${sheet.workbook_id}.${sheet.id}`;
            }

            return {
                ...sheet,
                l_id: updatedLid,
            };
        });

        return updatedSharedWbSheets;
    } catch (error) {
        console.log("Error in getSharedwithMeWorkBookSheets", error);
        
    }
}
export const optimizedGetSharedwithMeTemplateWorkbooksSheets = async (allsharedWithMeWorkBooks, userData) =>{
    try {
        let workbookIds= allsharedWithMeWorkBooks.map((wb)=>wb.id)
        const res = await POST(`${ELASTIC_URL}/sheet/getAllSheets`, {workbookIds});
        let allSharedWbSheets = res.data;
        const filteredSheets = allSharedWbSheets.filter(sheet=>{
            if(sheet.sheetType==='filterSheet'){
              return  sheet?.sheetTypeSpecificInfo?.owner === userData?.email
            }
            else{
                return sheet.sheetType !=='filterSheet'
            }
        
        })
        let updatedSharedWbSheets = filteredSheets.map((sheet) => {
            let updatedLid;
            if (sheet.id) {
                    updatedLid = `sharedTemplates.${sheet.workbook_id}.${sheet.id}`;
                    delete sheet.workspace_id
                    sheet.workspace_id = ""
            } 
            return {
                ...sheet,
                copyOfOriginal:true,
                l_id: updatedLid,
            };
        });

        return updatedSharedWbSheets;
    } catch (error) {
        console.log("Error in getSharedwithMeWorkBookSheets", error);
        
    }
}
export const filterAndRemoveDuplicateSheetIds=(notificationsArray)=> {
    const seen = new Set(); 
    const filteredIds = []; 
  
    for (const item of notificationsArray) {
      const metadata = JSON.parse(item.metadata); 
      if (metadata.type !== "Workbook" && item.entity_id !== null) {
        const entityId = item.entity_id;
        if (!seen.has(entityId)) { 
          filteredIds.push(entityId);
          seen.add(entityId); 
        }
      }
    }
  
    return filteredIds;
  }

export const filterAndRemoveDuplicatWorkbookIds=(notificationsArray)=> {
    const seen = new Set(); 
    const filteredIds = []; 
  
    for (const item of notificationsArray) {
      const metadata = JSON.parse(item.metadata); 
      if (metadata.type === "Workbook" && item.entity_id !== null) {
        const entityId = item.entity_id;
        if (!seen.has(entityId)) { 
          filteredIds.push(entityId);
          seen.add(entityId); 
        }
      }
    }
  
    return filteredIds;
  }
  export function allowAccessToAllColumns(columns) {
    if(columns) return columns.map(function (column) {
        if( column && column.colId !== '#'){
            column.editable = true;
            column.shareable = true;
            column.deleteable = true;
        }   
        return column;
    }).filter(Boolean)
    else return columns
}
export const formatEventFromxPad = (event) => {
    let startDate = new Date(event.startDate);
    let startTimeParts = event.startTime?.toUpperCase().split(':');
    let all_day = false;
    if (startTimeParts[0] === "12") startTimeParts[0] = "00"
    startDate.setHours(
        startTimeParts[2].includes("PM") && !(parseInt(startTimeParts[0], 10) === 12 && startTimeParts[1] === "00")
            ? parseInt(startTimeParts[0], 10) === 12 ? 12 : parseInt(startTimeParts[0], 10) + 12
            : parseInt(startTimeParts[0], 10)
    );
    startDate.setMinutes(parseInt(startTimeParts[1], 10));
    startDate.setSeconds(parseInt(startTimeParts[2], 10));

    let endDate = new Date(event.endDate);
    let endTimeParts = event.endTime.toUpperCase().split(':');
    if (endTimeParts[0] === "12") endTimeParts[0] = "00"
    endDate.setHours(
        endTimeParts[2].includes("PM") && !(parseInt(endTimeParts[0], 10) === 12 && endTimeParts[1] === "00")
            ? parseInt(endTimeParts[0], 10) === 12 ? 12 : parseInt(endTimeParts[0], 10) + 12
            : parseInt(endTimeParts[0], 10)
    );
    endDate.setMinutes(parseInt(endTimeParts[1], 10));
    endDate.setSeconds(parseInt(endTimeParts[2], 10));

    if (startDate.getHours() === 0 && startDate.getMinutes() === 0 &&
        endDate.getHours() === 23 && endDate.getMinutes() === 59) {
        all_day = true
    } else {
        all_day = false
      }
      return {startDate,endDate,all_day}
}

export const returnUserAndTimeStampFromLastUpdatedByUser=(field)=>{
    if(!field) return {user:'',timeStamp: new Date(1900, 4, 21, 10, 33, 30, 0)}
    let parts=field.split('-%^')
    return {user:parts[0],timeStamp:parts[1]?new Date(parts[1]): new Date(1900, 4, 21, 10, 33, 30, 0)}
}

export const checkIfSessionIsLatest=(sheet)=>{
    const {myCurrentSession}=store.getState().userReducer
    let {user,timeStamp}=returnUserAndTimeStampFromLastUpdatedByUser(myCurrentSession)
    let sheetSession=returnUserAndTimeStampFromLastUpdatedByUser(sheet.lastUpdatedByUser)
    if(myCurrentSession){
        if(!sheetSession.timeStamp){
            return true
        }
        else{
            return sheetSession.timeStamp<=timeStamp ? true : false
        }
    }
    return true;
}
export function checkForSpecialCharacters(text) {
    let specialCharacters = ['/', '*', ':', '?', '\',', '"', '<', '>', '|']
    for (let i = 0; i < specialCharacters.length; i++) {
        if (text?.includes(specialCharacters[i])) {
            return specialCharacters[i];
        }
    }
    return false
}

export const isSameSheet=(sheetIdentifier)=>{
    let url = window.location.pathname
    let parts = url.split('/sheet/');
    const isSameSheet = parts[1] === sheetIdentifier;
    return isSameSheet;

}

export const clearLocalStorageItemWithTimeout = (field, timeout) => {
    setTimeout(() => { localStorage.removeItem(field) }, timeout)
}

const PRESERVED_LS_KEYS = ['xspaces:net:pings', 'xspaces:net:daily', 'xspaces:net:speedtests'];

export const clearLocalStorageExceptNetworkKeys = () => {
    const preserved = PRESERVED_LS_KEYS.reduce((acc, key) => {
        const val = localStorage.getItem(key);
        if (val !== null) acc[key] = val;
        return acc;
    }, {});
    localStorage.clear();
    Object.entries(preserved).forEach(([key, val]) => localStorage.setItem(key, val));
}
export const navigateToUrlOnNewTab=(url)=>{
    const newTab = window.open(url, '_blank');	
        newTab.focus();
}
export const formatAttachmentDate=(date)=>{
    const options={month:'short', day:'numeric',year:'numeric',hour:'numeric',minute:'numeric',hour12:true};
    const formattedDate=new Date(date).toLocaleDateString('en-US',options);
    return formattedDate;
}

export const getSheetInfo = async (sheetId) => {
    let result = await POST(`${ELASTIC_URL}/sheet/getRequiredFields`, { sheetId, fields: ['sheet_identifier', 'user_email', 'deactivated', 'sessionId', 'sessionUpdatedByUser', 'workbook_id', 'parent', 'l_id', 'locked'] })
    return result.data;
}

export const getSheetCheckInAgentData= async (sheetId) => {
    let result = await POST(`${ELASTIC_URL}/sheet/getRequiredFields`, { sheetId, fields: ['checkInAgentData'] })
    return result.data?.checkInAgentData;
}

export const getSheetInfoBySheetIdentifier = async (sheetIdentifier) => {
    let result = await POST(`${ELASTIC_URL}/sheet/getRequiredFieldsUsingSheetIdentifier`, { sheet_identifier: sheetIdentifier, fields: ['user_email', 'deactivated'] })
    if (result && result.data) {
        return { ...result.data }
    }
}

export const partialRefresh = () => async (dispatch) => {
    const { currentSelectedSheet, isShared } = store.getState().sheetReducer;
    const { userData } = store.getState().userReducer

    dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: true });
    let oldSelectedSheet = currentSelectedSheet
    let lastUpdatedByUser = userData?.email + '%' + new Date()
    dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, currentSelectedSheet: "" });
    setTimeout(() => {
        oldSelectedSheet.locked = userData?.email
        oldSelectedSheet.lastUpdatedByUser = lastUpdatedByUser
        delete oldSelectedSheet.Rows
        dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, currentSelectedSheet: oldSelectedSheet, selectedSheetId: isShared?"":currentSelectedSheet.id })
        dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false })
    }, 1000)

}

export const getDocumentAccess = async(id, user) =>{
    try {
        const data = {
            entity_id : id,
            user_email : user
        }
        const response = await POST (`/access/getAccessByEntityIdForAUser`, data);
        return response.data;
    } catch (error) {
        console.log("Error in getDocumentAccess in helper.js", error);
        
    }
}

export const buildLookupTable = async (lookupTable, gridRef) => {
    const rowData = [];
    gridRef.current.api.forEachNode((node) => rowData.push(node.data));
  
    // Build lookup table dynamically
    Array.isArray(rowData) && rowData.forEach((item) => {
        lookupTable[item.l_id] = item.primaryCol; // Assuming `value` is the actual data
      });
  };

 export const resolveWorkbookById = (workbookList,workbookId) => {
    return workbookList.find(wb => wb.id === workbookId);
  };

 export const openMoveCopySheetModalHelper = async (
    sheet, 
    setMoveCopySheet,
    setMoveCopyWorkbook,
    setMoveCopySheetList,
    setMoveCopyModalOpen,
    workbookList,
    sharedWithMeWorkBooks
    ) => {
    if (!sheet?.workbook_id) return;

     const lockInfo = await checkIfSheetLocked(sheet.id)

     if (lockInfo.isLocked) {
         renderAlert(`Sheet is locked by ${lockInfo.email}`, 'error')
         return
     }
    const workbook = resolveWorkbookById([...workbookList, ...sharedWithMeWorkBooks], sheet.workbook_id);
    if (!workbook) {
      renderAlert('Workbook not found', 'error');
      return;
    }
  
    let sheets = [];
  
    try {
      sheets = await fetchSheetListByWorkbookId(workbook.id);
    } catch (err) {
      console.error('Failed to fetch sheets:', err);
      renderAlert('Failed to load sheets', 'error');
      return;
    }
  
    setMoveCopySheet(sheet);
    setMoveCopyWorkbook(workbook);
    setMoveCopySheetList(sheets);
    setMoveCopyModalOpen(true);
  };
  

  const checkIfSheetLocked = async (sheetId) => {
    const response = await POST(
      `${ELASTIC_URL}/sheet/getRequiredFields`,
      { sheetId, fields: ['locked', 'lockedByEmail'] }
    )
  
    const result = response?.data
    const { userData } = store.getState().userReducer
  
    if (result?.locked && result.locked !== userData.email) {
      return {
        isLocked: true,
        email: result.locked
      }
    }
  
    return { isLocked: false }
  }
  
  